import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Ad from "@/pages/Ad";
import Brain from "@/pages/Brain";
import JobPlan from "@/pages/JobPlan";
import InvoiceView from "@/pages/InvoiceView";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/quote" element={<Landing scrollTo="quote" />} />
          <Route path="/free-estimate" element={<Landing scrollTo="quote" />} />
          <Route path="/services" element={<Landing scrollTo="services" />} />
          <Route path="/tree-removal" element={<Landing scrollTo="services" />} />
          <Route path="/tree-trimming" element={<Landing scrollTo="services" />} />
          <Route path="/storm" element={<Landing scrollTo="quote" />} />
          <Route path="/emergency" element={<Landing scrollTo="quote" />} />
          <Route path="/service-area" element={<Landing scrollTo="area" />} />
          <Route path="/contact" element={<Landing scrollTo="quote" />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/ad" element={<Ad />} />
          <Route path="/call" element={<Ad />} />
          <Route path="/text" element={<Ad />} />
          <Route path="/brain" element={<Brain />} />
          <Route path="/brain/plan/:planId" element={<JobPlan />} />
          <Route path="/invoice/:leadId/:docId" element={<InvoiceView />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#1B2A22",
            color: "#F4F1ED",
            border: "2px solid #1B2A22",
            borderRadius: "0",
            fontFamily: "'IBM Plex Sans', sans-serif",
            boxShadow: "4px 4px 0 0 #E65C00",
          },
        }}
      />
    </div>
  );
}

export default App;
